// 2026-09-22：统一功能配置匹配、视频地址校验和空配置回退，不影响原功能权限。
export interface FunctionGuide { path: string; description: string; videoUrl: string }
export interface FunctionGuideCatalogItem extends FunctionGuide { functionName: string; parentName: string }
export const normalizeFunctionPath = (value: unknown): string =>
  String(value || '').trim().split(/[?#]/, 1)[0].replace(/\/+$/, '').toLowerCase()

export const safeFunctionVideoUrl = (value: unknown): string => {
  const text = String(value || '').trim()
  if (!text || text.length > 1200 || /[\s\\]/.test(text)) return ''
  try {
    const url = new URL(text)
    return ['https:', 'http:'].includes(url.protocol) && !!url.hostname && !url.username && !url.password ? text : ''
  } catch { return '' }
}

export const normalizeFunctionGuide = (value: Partial<FunctionGuide>): FunctionGuide => ({
  path: normalizeFunctionPath(value.path), description: String(value.description || '').trim(),
  videoUrl: safeFunctionVideoUrl(value.videoUrl)
})

export const findFunctionGuide = (guides: FunctionGuide[], path: string): FunctionGuide | undefined => {
  let current = normalizeFunctionPath(path)
  while (current) {
    const found = guides.find(item => normalizeFunctionPath(item.path) === current)
    if (found) return found
    current = current.slice(0, Math.max(0, current.lastIndexOf('/')))
  }
  return undefined
}

export const canConfigureFunctionGuides = (user: any, functions: any): boolean =>
  Number(user?.orgId) === 1000 && (Number(user?.roleId) === 1 || (Array.isArray(functions) && functions.some(item =>
    String(item.functionKey || '').toLowerCase() === 'system.functionguides' && ['FUNC', 'MENU'].includes(item.functionType)
    && !Number(item.disabled || 0))))
